import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import HolidaysCalculator from './components/HolidaysCalculator';
import Footer from './components/Footer';
import Header from './components/Header';

function App() {
  return (
    <div className="App">
      <Header />
      <HolidaysCalculator />
      <Footer />
    </div>
  );
}

export default App;
